import { TYPES } from '../../../utils/flattenTree/utils/consts';
import { Operation } from '../LibraryView/ApiSectionView/OperationsList/Operation';
import { Property } from '../LibraryView/ApiSectionView/PropertiesList/Property';
import { MainEntity } from '../LibraryView/ApiSectionView/MainEntity';
import { GuideMarkdown } from '../LibraryView/ApiSectionView/GuideMarkdownList/GuideMarkdown/GuideMarkdown';
import React from 'react';
import { IndexPage } from '../LibraryView/IndexPage';
import { Event } from '../LibraryView/ApiSectionView/EventsList/Event/Event';
import { sectionPrefix } from '../NavigationMenu/utils';

const renderEvent =
  (prefixNode, prefix, subscribeToIntersectionObserver, urlFormat) => () => {
    const event = prefixNode.data.events.find(isSameAsCurrentEntry(urlFormat));
    return (
      <Event
        event={event}
        node={prefixNode}
        prefix={prefix}
        subscribeToIntersectionObserver={subscribeToIntersectionObserver}
      />
    );
  };

const getNodePath = (node, prefix) => {
  return prefix
    ? sectionPrefix(prefix, node.data.urlFormat)
    : node.data.urlFormat;
};

const isSameAsCurrentEntry = (urlFormat) => (entry) =>
  urlFormat === entry.urlFormat;

export const getRenderers = (
  prefixNode,
  prefix,
  urlFormat,
  subscribeToIntersectionObserver,
) => {
  return {
    [TYPES.OPERATION]: () => {
      const operation = prefixNode.data.operations.find(
        isSameAsCurrentEntry(urlFormat),
      );
      return (
        <Operation node={prefixNode} operation={operation} prefix={prefix} />
      );
    },
    [TYPES.CLIENT_EVENT]: () => {
      const clientEvent = prefixNode.data.clientEvents.find(
        isSameAsCurrentEntry(urlFormat),
      );
      return (
        <Operation node={prefixNode} operation={clientEvent} prefix={prefix} />
      );
    },
    [TYPES.PROPERTY]: () => {
      const property = prefixNode.data.properties.find(
        isSameAsCurrentEntry(urlFormat),
      );
      return (
        <Property
          property={property}
          prefix={prefix}
          subscribeToIntersectionObserver={subscribeToIntersectionObserver}
        />
      );
    },
    [TYPES.MAIN_ENTITY]: () => {
      return (
        <MainEntity
          node={prefixNode}
          prefix={prefix}
          subscribeToIntersectionObserver={subscribeToIntersectionObserver}
        />
      );
    },
    [TYPES.MD]: () => {
      const mdFile = prefixNode.data.relatedGuides.find(
        isSameAsCurrentEntry(urlFormat),
      );
      return <GuideMarkdown mdFile={mdFile} prefix={prefix} />;
    },
    [TYPES.ARTICLES_CATEGORY]: () => {
      const relatedGuide = prefixNode.data.relatedGuides[0];
      return <GuideMarkdown mdFile={relatedGuide} prefix={prefix} />;
    },
    [TYPES.CATEGORY]: () => {
      return (
        <IndexPage
          node={prefixNode}
          prefix={getNodePath(prefixNode, prefix)}
          depth={0}
          isOpened={true}
          subscribeToIntersectionObserver={subscribeToIntersectionObserver}
        />
      );
    },
    [TYPES.SECTION]: () => {
      const node = prefixNode[`/${urlFormat}`];
      return (
        <IndexPage
          node={node}
          prefix={getNodePath(node, prefix)}
          depth={1}
          isOpened={true}
          subscribeToIntersectionObserver={subscribeToIntersectionObserver}
        />
      );
    },
    [TYPES.EVENT]: renderEvent(
      prefixNode,
      prefix,
      subscribeToIntersectionObserver,
      urlFormat,
    ),
    [TYPES.WEBHOOK]: renderEvent(
      prefixNode,
      prefix,
      subscribeToIntersectionObserver,
      urlFormat,
    ),
  };
};
